/**
 * Admin (super-admin) API client. Uses fetch with admin JWT.
 * Do not use for /api/tenant/* - tenant routes use the normal app token.
 */
const BASE = process.env.REACT_APP_API_URL || '';

async function request(method, path, body, token) {
  const url = path.startsWith('http') ? path : BASE + path;
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (token) opts.headers.Authorization = 'Bearer ' + token;
  if (body != null) opts.body = JSON.stringify(body);
  const res = await fetch(url, opts);
  let data = null;
  const ct = res.headers.get('content-type');
  if (ct && ct.includes('application/json')) {
    try { data = await res.json(); } catch (_) {}
  }
  if (!res.ok) {
    const msg = (data && data.error) || ('Request failed' + (res.status ? ' (' + res.status + ')' : ''));
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function adminLogin(credentials) {
  return request('POST', '/api/admin/auth/login', credentials);
}

export async function listTenants(opts, token) {
  const params = new URLSearchParams();
  if (opts && opts.q != null && opts.q !== '') params.set('q', opts.q);
  if (opts && opts.includeDeleted) params.set('includeDeleted', 'true');
  const query = params.toString() ? '?' + params.toString() : '';
  return request('GET', '/api/admin/tenants' + query, null, token);
}

export async function deleteTenant(tenantId, token) {
  return request('DELETE', '/api/admin/tenants/' + encodeURIComponent(tenantId), null, token);
}

export async function restoreTenant(tenantId, token) {
  return request('POST', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/restore', null, token);
}

export async function purgeTenant(tenantId, token) {
  return request('POST', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/purge', null, token);
}

export async function createTenant(payload, token) {
  return request('POST', '/api/admin/tenants', payload, token);
}

export async function seedTenantAdmin(tenantId, payload, token) {
  return request('POST', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/seed-admin', payload, token);
}

export async function updateTenantStatus(tenantId, payload, token) {
  return request('PATCH', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/status', payload, token);
}

export async function clearTenantData(tenantId, token) {
  return request('POST', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/clear-all-data', null, token);
}

export async function getTenantStats(tenantId, token) {
  return request('GET', '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/stats', null, token);
}

export async function getAllTenantsStats(token) {
  return request('GET', '/api/admin/tenants/stats/all', null, token);
}

export async function backupTenant(tenantId, token) {
  const url = (process.env.REACT_APP_API_URL || '') + '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/backup';
  const res = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
  if (!res.ok) {
    let msg = 'Backup failed';
    try { const d = await res.json(); msg = d.error || msg; } catch (_) {}
    throw new Error(msg);
  }
  return res;
}

export async function restoreTenantDryRun(tenantId, file, token) {
  const url = (process.env.REACT_APP_API_URL || '') + '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/restore-backup';
  const form = new FormData();
  form.append('backup', file);
  form.append('dryRun', 'true');
  const res = await fetch(url, { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: form });
  if (!res.ok) {
    let msg = 'Restore check failed';
    try { const d = await res.json(); msg = d.error || msg; } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}

export async function restoreTenantConfirm(tenantId, file, token) {
  const url = (process.env.REACT_APP_API_URL || '') + '/api/admin/tenants/' + encodeURIComponent(tenantId) + '/restore-backup';
  const form = new FormData();
  form.append('backup', file);
  const res = await fetch(url, { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: form });
  if (!res.ok) {
    let msg = 'Restore failed';
    try { const d = await res.json(); msg = d.error || msg; } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}
